var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-container"},[_c('img',{staticClass:"responsive-image",attrs:{"src":this.imgSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }